export default {
  cityArray: [
    {
      'pkid': '110100',
      'name': '北京市市辖区',
      'shortName': '北京',
      'lng': '116.405285',
      'lat': '39.904989',
      'pinyin': 'Beijing'
    },
    {
      'pkid': '120100',
      'name': '天津市市辖区',
      'shortName': '天津市辖区',
      'lng': '117.190182',
      'lat': '39.125596',
      'pinyin': 'Tianjin'
    },
    {
      'pkid': '130100',
      'name': '石家庄市',
      'shortName': '石家庄',
      'lng': '114.502461',
      'lat': '38.045474',
      'pinyin': 'Shijiazhuang'
    },
    {
      'pkid': '130200',
      'name': '唐山市',
      'shortName': '唐山',
      'lng': '118.175393',
      'lat': '39.635113',
      'pinyin': 'Tangshan'
    },
    {
      'pkid': '130300',
      'name': '秦皇岛市',
      'shortName': '秦皇岛',
      'lng': '119.586579',
      'lat': '39.942531',
      'pinyin': 'Qinhuangdao'
    },
    {
      'pkid': '130400',
      'name': '邯郸市',
      'shortName': '邯郸',
      'lng': '114.490686',
      'lat': '36.612273',
      'pinyin': 'Handan'
    },
    {
      'pkid': '130500',
      'name': '邢台市',
      'shortName': '邢台',
      'lng': '114.508851',
      'lat': '37.068200',
      'pinyin': 'Xingtai'
    },
    {
      'pkid': '130600',
      'name': '保定市',
      'shortName': '保定',
      'lng': '115.482331',
      'lat': '38.867657',
      'pinyin': 'Baoding'
    },
    {
      'pkid': '130700',
      'name': '张家口市',
      'shortName': '张家口',
      'lng': '114.884091',
      'lat': '40.811901',
      'pinyin': 'Zhangjiakou'
    },
    {
      'pkid': '130800',
      'name': '承德市',
      'shortName': '承德',
      'lng': '117.939152',
      'lat': '40.976204',
      'pinyin': 'Chengde'
    },
    {
      'pkid': '130900',
      'name': '沧州市',
      'shortName': '沧州',
      'lng': '116.857461',
      'lat': '38.310582',
      'pinyin': 'Cangzhou'
    },
    {
      'pkid': '131000',
      'name': '廊坊市',
      'shortName': '廊坊',
      'lng': '116.704441',
      'lat': '39.523927',
      'pinyin': 'Langfang'
    },
    {
      'pkid': '131100',
      'name': '衡水市',
      'shortName': '衡水',
      'lng': '115.665993',
      'lat': '37.735097',
      'pinyin': 'Hengshui'
    },
    {
      'pkid': '140100',
      'name': '太原市',
      'shortName': '太原',
      'lng': '112.549248',
      'lat': '37.857014',
      'pinyin': 'Taiyuan'
    },
    {
      'pkid': '140200',
      'name': '大同市',
      'shortName': '大同',
      'lng': '113.295259',
      'lat': '40.090310',
      'pinyin': 'Datong'
    },
    {
      'pkid': '140300',
      'name': '阳泉市',
      'shortName': '阳泉',
      'lng': '113.583285',
      'lat': '37.861188',
      'pinyin': 'Yangquan'
    },
    {
      'pkid': '140400',
      'name': '长治市',
      'shortName': '长治',
      'lng': '113.113556',
      'lat': '36.191112',
      'pinyin': 'Changzhi'
    },
    {
      'pkid': '140500',
      'name': '晋城市',
      'shortName': '晋城',
      'lng': '112.851274',
      'lat': '35.497553',
      'pinyin': 'Jincheng'
    },
    {
      'pkid': '140600',
      'name': '朔州市',
      'shortName': '朔州',
      'lng': '112.433387',
      'lat': '39.331261',
      'pinyin': 'Shuozhou'
    },
    {
      'pkid': '140700',
      'name': '晋中市',
      'shortName': '晋中',
      'lng': '112.736465',
      'lat': '37.696495',
      'pinyin': 'Jinzhong'
    },
    {
      'pkid': '140800',
      'name': '运城市',
      'shortName': '运城',
      'lng': '111.003957',
      'lat': '35.022778',
      'pinyin': 'Yuncheng'
    },
    {
      'pkid': '140900',
      'name': '忻州市',
      'shortName': '忻州',
      'lng': '112.733538',
      'lat': '38.417690',
      'pinyin': 'Xinzhou'
    },
    {
      'pkid': '141000',
      'name': '临汾市',
      'shortName': '临汾',
      'lng': '111.517973',
      'lat': '36.084150',
      'pinyin': 'Linfen'
    },
    {
      'pkid': '141100',
      'name': '吕梁市',
      'shortName': '吕梁',
      'lng': '111.134335',
      'lat': '37.524366',
      'pinyin': 'Lvliang'
    },
    {
      'pkid': '150100',
      'name': '呼和浩特市',
      'shortName': '呼和浩特',
      'lng': '111.670801',
      'lat': '40.818311',
      'pinyin': 'Hohhot'
    },
    {
      'pkid': '150200',
      'name': '包头市',
      'shortName': '包头',
      'lng': '109.840405',
      'lat': '40.658168',
      'pinyin': 'Baotou'
    },
    {
      'pkid': '150300',
      'name': '乌海市',
      'shortName': '乌海',
      'lng': '106.825563',
      'lat': '39.673734',
      'pinyin': 'Wuhai'
    },
    {
      'pkid': '150400',
      'name': '赤峰市',
      'shortName': '赤峰',
      'lng': '118.956806',
      'lat': '42.275317',
      'pinyin': 'Chifeng'
    },
    {
      'pkid': '150500',
      'name': '通辽市',
      'shortName': '通辽',
      'lng': '122.263119',
      'lat': '43.617429',
      'pinyin': 'Tongliao'
    },
    {
      'pkid': '150600',
      'name': '鄂尔多斯市',
      'shortName': '鄂尔多斯',
      'lng': '109.990290',
      'lat': '39.817179',
      'pinyin': 'Ordos'
    },
    {
      'pkid': '150700',
      'name': '呼伦贝尔市',
      'shortName': '呼伦贝尔',
      'lng': '119.758168',
      'lat': '49.215333',
      'pinyin': 'Hulunber'
    },
    {
      'pkid': '150800',
      'name': '巴彦淖尔市',
      'shortName': '巴彦淖尔',
      'lng': '107.416959',
      'lat': '40.757402',
      'pinyin': 'Bayan Nur'
    },
    {
      'pkid': '150900',
      'name': '乌兰察布市',
      'shortName': '乌兰察布',
      'lng': '113.114543',
      'lat': '41.034126',
      'pinyin': 'Ulanqab'
    },
    {
      'pkid': '152200',
      'name': '兴安盟',
      'shortName': '兴安盟',
      'lng': '122.070317',
      'lat': '46.076268',
      'pinyin': 'Hinggan'
    },
    {
      'pkid': '152500',
      'name': '锡林郭勒盟',
      'shortName': '锡林郭勒盟',
      'lng': '116.090996',
      'lat': '43.944018',
      'pinyin': 'Xilin Gol'
    },
    {
      'pkid': '152900',
      'name': '阿拉善盟',
      'shortName': '阿拉善盟',
      'lng': '105.706422',
      'lat': '38.844814',
      'pinyin': 'Alxa'
    },
    {
      'pkid': '210100',
      'name': '沈阳市',
      'shortName': '沈阳',
      'lng': '123.429096',
      'lat': '41.796767',
      'pinyin': 'Shenyang'
    },
    {
      'pkid': '210200',
      'name': '大连市',
      'shortName': '大连',
      'lng': '121.618622',
      'lat': '38.914590',
      'pinyin': 'Dalian'
    },
    {
      'pkid': '210300',
      'name': '鞍山市',
      'shortName': '鞍山',
      'lng': '122.995632',
      'lat': '41.110626',
      'pinyin': 'Anshan'
    },
    {
      'pkid': '210400',
      'name': '抚顺市',
      'shortName': '抚顺',
      'lng': '123.921109',
      'lat': '41.875956',
      'pinyin': 'Fushun'
    },
    {
      'pkid': '210500',
      'name': '本溪市',
      'shortName': '本溪',
      'lng': '123.770519',
      'lat': '41.297909',
      'pinyin': 'Benxi'
    },
    {
      'pkid': '210600',
      'name': '丹东市',
      'shortName': '丹东',
      'lng': '124.383044',
      'lat': '40.124296',
      'pinyin': 'Dandong'
    },
    {
      'pkid': '210700',
      'name': '锦州市',
      'shortName': '锦州',
      'lng': '121.135742',
      'lat': '41.119269',
      'pinyin': 'Jinzhou'
    },
    {
      'pkid': '210800',
      'name': '营口市',
      'shortName': '营口',
      'lng': '122.235151',
      'lat': '40.667432',
      'pinyin': 'Yingkou'
    },
    {
      'pkid': '210900',
      'name': '阜新市',
      'shortName': '阜新',
      'lng': '121.648962',
      'lat': '42.011796',
      'pinyin': 'Fuxin'
    },
    {
      'pkid': '211000',
      'name': '辽阳市',
      'shortName': '辽阳',
      'lng': '123.181520',
      'lat': '41.269402',
      'pinyin': 'Liaoyang'
    },
    {
      'pkid': '211100',
      'name': '盘锦市',
      'shortName': '盘锦',
      'lng': '122.069570',
      'lat': '41.124484',
      'pinyin': 'Panjin'
    },
    {
      'pkid': '211200',
      'name': '铁岭市',
      'shortName': '铁岭',
      'lng': '123.844279',
      'lat': '42.290585',
      'pinyin': 'Tieling'
    },
    {
      'pkid': '211300',
      'name': '朝阳市',
      'shortName': '朝阳',
      'lng': '120.451176',
      'lat': '41.576758',
      'pinyin': 'Chaoyang'
    },
    {
      'pkid': '211400',
      'name': '葫芦岛市',
      'shortName': '葫芦岛',
      'lng': '120.856394',
      'lat': '40.755572',
      'pinyin': 'Huludao'
    },
    {
      'pkid': '211500',
      'name': '金普新区',
      'shortName': '金普新区',
      'lng': '121.789627',
      'lat': '39.055451',
      'pinyin': 'Jinpuxinqu'
    },
    {
      'pkid': '220100',
      'name': '长春市',
      'shortName': '长春',
      'lng': '125.324500',
      'lat': '43.886841',
      'pinyin': 'Changchun'
    },
    {
      'pkid': '220200',
      'name': '吉林市',
      'shortName': '吉林',
      'lng': '126.553020',
      'lat': '43.843577',
      'pinyin': 'Jilin'
    },
    {
      'pkid': '220300',
      'name': '四平市',
      'shortName': '四平',
      'lng': '124.370785',
      'lat': '43.170344',
      'pinyin': 'Siping'
    },
    {
      'pkid': '220400',
      'name': '辽源市',
      'shortName': '辽源',
      'lng': '125.145349',
      'lat': '42.902692',
      'pinyin': 'Liaoyuan'
    },
    {
      'pkid': '220500',
      'name': '通化市',
      'shortName': '通化',
      'lng': '125.936501',
      'lat': '41.721177',
      'pinyin': 'Tonghua'
    },
    {
      'pkid': '220600',
      'name': '白山市',
      'shortName': '白山',
      'lng': '126.427839',
      'lat': '41.942505',
      'pinyin': 'Baishan'
    },
    {
      'pkid': '220700',
      'name': '松原市',
      'shortName': '松原',
      'lng': '124.823608',
      'lat': '45.118243',
      'pinyin': 'Songyuan'
    },
    {
      'pkid': '220800',
      'name': '白城市',
      'shortName': '白城',
      'lng': '122.841114',
      'lat': '45.619026',
      'pinyin': 'Baicheng'
    },
    {
      'pkid': '222400',
      'name': '延边朝鲜族自治州',
      'shortName': '延边',
      'lng': '129.513228',
      'lat': '42.904823',
      'pinyin': 'Yanbian'
    },
    {
      'pkid': '230100',
      'name': '哈尔滨市',
      'shortName': '哈尔滨',
      'lng': '126.642464',
      'lat': '45.756967',
      'pinyin': 'Harbin'
    },
    {
      'pkid': '230200',
      'name': '齐齐哈尔市',
      'shortName': '齐齐哈尔',
      'lng': '123.957920',
      'lat': '47.342081',
      'pinyin': 'Qiqihar'
    },
    {
      'pkid': '230300',
      'name': '鸡西市',
      'shortName': '鸡西',
      'lng': '130.975966',
      'lat': '45.300046',
      'pinyin': 'Jixi'
    },
    {
      'pkid': '230400',
      'name': '鹤岗市',
      'shortName': '鹤岗',
      'lng': '130.277487',
      'lat': '47.332085',
      'pinyin': 'Hegang'
    },
    {
      'pkid': '230500',
      'name': '双鸭山市',
      'shortName': '双鸭山',
      'lng': '131.157304',
      'lat': '46.643442',
      'pinyin': 'Shuangyashan'
    },
    {
      'pkid': '230600',
      'name': '大庆市',
      'shortName': '大庆',
      'lng': '125.112720',
      'lat': '46.590734',
      'pinyin': 'Daqing'
    },
    {
      'pkid': '230700',
      'name': '伊春市',
      'shortName': '伊春',
      'lng': '128.899396',
      'lat': '47.724775',
      'pinyin': 'Yichun'
    },
    {
      'pkid': '230800',
      'name': '佳木斯市',
      'shortName': '佳木斯',
      'lng': '130.361634',
      'lat': '46.809606',
      'pinyin': 'Jiamusi'
    },
    {
      'pkid': '230900',
      'name': '七台河市',
      'shortName': '七台河',
      'lng': '131.015584',
      'lat': '45.771266',
      'pinyin': 'Qitaihe'
    },
    {
      'pkid': '231000',
      'name': '牡丹江市',
      'shortName': '牡丹江',
      'lng': '129.618602',
      'lat': '44.582962',
      'pinyin': 'Mudanjiang'
    },
    {
      'pkid': '231100',
      'name': '黑河市',
      'shortName': '黑河',
      'lng': '127.499023',
      'lat': '50.249585',
      'pinyin': 'Heihe'
    },
    {
      'pkid': '231200',
      'name': '绥化市',
      'shortName': '绥化',
      'lng': '126.992930',
      'lat': '46.637393',
      'pinyin': 'Suihua'
    },
    {
      'pkid': '232700',
      'name': '大兴安岭地区',
      'shortName': '大兴安岭',
      'lng': '124.711526',
      'lat': '52.335262',
      'pinyin': 'DaXingAnLing'
    },
    {
      'pkid': '310100',
      'name': '上海市市辖区',
      'shortName': '上海市辖区',
      'lng': '121.472644',
      'lat': '31.231706',
      'pinyin': 'Shanghai'
    },
    {
      'pkid': '320100',
      'name': '南京市',
      'shortName': '南京',
      'lng': '118.767413',
      'lat': '32.041544',
      'pinyin': 'Nanjing'
    },
    {
      'pkid': '320200',
      'name': '无锡市',
      'shortName': '无锡',
      'lng': '120.301663',
      'lat': '31.574729',
      'pinyin': 'Wuxi'
    },
    {
      'pkid': '320300',
      'name': '徐州市',
      'shortName': '徐州',
      'lng': '117.184811',
      'lat': '34.261792',
      'pinyin': 'Xuzhou'
    },
    {
      'pkid': '320400',
      'name': '常州市',
      'shortName': '常州',
      'lng': '119.946973',
      'lat': '31.772752',
      'pinyin': 'Changzhou'
    },
    {
      'pkid': '320500',
      'name': '苏州市',
      'shortName': '苏州',
      'lng': '120.619585',
      'lat': '31.299379',
      'pinyin': 'Suzhou'
    },
    {
      'pkid': '320600',
      'name': '南通市',
      'shortName': '南通',
      'lng': '120.864608',
      'lat': '32.016212',
      'pinyin': 'Nantong'
    },
    {
      'pkid': '320700',
      'name': '连云港市',
      'shortName': '连云港',
      'lng': '119.178821',
      'lat': '34.600018',
      'pinyin': 'Lianyungang'
    },
    {
      'pkid': '320800',
      'name': '淮安市',
      'shortName': '淮安',
      'lng': '119.021265',
      'lat': '33.597506',
      'pinyin': 'Huai\'an'
    },
    {
      'pkid': '320900',
      'name': '盐城市',
      'shortName': '盐城',
      'lng': '120.139998',
      'lat': '33.377631',
      'pinyin': 'Yancheng'
    },
    {
      'pkid': '321000',
      'name': '扬州市',
      'shortName': '扬州',
      'lng': '119.421003',
      'lat': '32.393159',
      'pinyin': 'Yangzhou'
    },
    {
      'pkid': '321100',
      'name': '镇江市',
      'shortName': '镇江',
      'lng': '119.452753',
      'lat': '32.204402',
      'pinyin': 'Zhenjiang'
    },
    {
      'pkid': '321200',
      'name': '泰州市',
      'shortName': '泰州',
      'lng': '119.915176',
      'lat': '32.484882',
      'pinyin': 'Taizhou'
    },
    {
      'pkid': '321300',
      'name': '宿迁市',
      'shortName': '宿迁',
      'lng': '118.275162',
      'lat': '33.963008',
      'pinyin': 'Suqian'
    },
    {
      'pkid': '330100',
      'name': '杭州市',
      'shortName': '杭州',
      'lng': '120.153576',
      'lat': '30.287459',
      'pinyin': 'Hangzhou'
    },
    {
      'pkid': '330200',
      'name': '宁波市',
      'shortName': '宁波',
      'lng': '121.549792',
      'lat': '29.868388',
      'pinyin': 'Ningbo'
    },
    {
      'pkid': '330300',
      'name': '温州市',
      'shortName': '温州',
      'lng': '120.672111',
      'lat': '28.000575',
      'pinyin': 'Wenzhou'
    },
    {
      'pkid': '330400',
      'name': '嘉兴市',
      'shortName': '嘉兴',
      'lng': '120.750865',
      'lat': '30.762653',
      'pinyin': 'Jiaxing'
    },
    {
      'pkid': '330500',
      'name': '湖州市',
      'shortName': '湖州',
      'lng': '120.102398',
      'lat': '30.867198',
      'pinyin': 'Huzhou'
    },
    {
      'pkid': '330600',
      'name': '绍兴市',
      'shortName': '绍兴',
      'lng': '120.582112',
      'lat': '29.997117',
      'pinyin': 'Shaoxing'
    },
    {
      'pkid': '330700',
      'name': '金华市',
      'shortName': '金华',
      'lng': '119.649506',
      'lat': '29.089524',
      'pinyin': 'Jinhua'
    },
    {
      'pkid': '330800',
      'name': '衢州市',
      'shortName': '衢州',
      'lng': '118.872630',
      'lat': '28.941708',
      'pinyin': 'Quzhou'
    },
    {
      'pkid': '330900',
      'name': '舟山市',
      'shortName': '舟山',
      'lng': '122.106863',
      'lat': '30.016028',
      'pinyin': 'Zhoushan'
    },
    {
      'pkid': '331000',
      'name': '台州市',
      'shortName': '台州',
      'lng': '121.428599',
      'lat': '28.661378',
      'pinyin': 'Taizhou'
    },
    {
      'pkid': '331100',
      'name': '丽水市',
      'shortName': '丽水',
      'lng': '119.921786',
      'lat': '28.451993',
      'pinyin': 'Lishui'
    },
    {
      'pkid': '331200',
      'name': '舟山群岛新区',
      'shortName': '舟山新区',
      'lng': '122.317657',
      'lat': '29.813242',
      'pinyin': 'Zhoushan'
    },
    {
      'pkid': '340100',
      'name': '合肥市',
      'shortName': '合肥',
      'lng': '117.283042',
      'lat': '31.861190',
      'pinyin': 'Hefei'
    },
    {
      'pkid': '340200',
      'name': '芜湖市',
      'shortName': '芜湖',
      'lng': '118.376451',
      'lat': '31.326319',
      'pinyin': 'Wuhu'
    },
    {
      'pkid': '340300',
      'name': '蚌埠市',
      'shortName': '蚌埠',
      'lng': '117.363228',
      'lat': '32.939667',
      'pinyin': 'Bengbu'
    },
    {
      'pkid': '340400',
      'name': '淮南市',
      'shortName': '淮南',
      'lng': '117.018329',
      'lat': '32.647574',
      'pinyin': 'Huainan'
    },
    {
      'pkid': '340500',
      'name': '马鞍山市',
      'shortName': '马鞍山',
      'lng': '118.507906',
      'lat': '31.689362',
      'pinyin': 'Ma\'anshan'
    },
    {
      'pkid': '340600',
      'name': '淮北市',
      'shortName': '淮北',
      'lng': '116.794664',
      'lat': '33.971707',
      'pinyin': 'Huaibei'
    },
    {
      'pkid': '340700',
      'name': '铜陵市',
      'shortName': '铜陵',
      'lng': '117.816576',
      'lat': '30.929935',
      'pinyin': 'Tongling'
    },
    {
      'pkid': '340800',
      'name': '安庆市',
      'shortName': '安庆',
      'lng': '117.043551',
      'lat': '30.508830',
      'pinyin': 'Anqing'
    },
    {
      'pkid': '341000',
      'name': '黄山市',
      'shortName': '黄山',
      'lng': '118.317325',
      'lat': '29.709239',
      'pinyin': 'Huangshan'
    },
    {
      'pkid': '341100',
      'name': '滁州市',
      'shortName': '滁州',
      'lng': '118.316264',
      'lat': '32.303627',
      'pinyin': 'Chuzhou'
    },
    {
      'pkid': '341200',
      'name': '阜阳市',
      'shortName': '阜阳',
      'lng': '115.819729',
      'lat': '32.896969',
      'pinyin': 'Fuyang'
    },
    {
      'pkid': '341300',
      'name': '宿州市',
      'shortName': '宿州',
      'lng': '116.984084',
      'lat': '33.633891',
      'pinyin': 'Suzhou'
    },
    {
      'pkid': '341500',
      'name': '六安市',
      'shortName': '六安',
      'lng': '116.507676',
      'lat': '31.752889',
      'pinyin': 'Lu\'an'
    },
    {
      'pkid': '341600',
      'name': '亳州市',
      'shortName': '亳州',
      'lng': '115.782939',
      'lat': '33.869338',
      'pinyin': 'Bozhou'
    },
    {
      'pkid': '341700',
      'name': '池州市',
      'shortName': '池州',
      'lng': '117.489157',
      'lat': '30.656037',
      'pinyin': 'Chizhou'
    },
    {
      'pkid': '341800',
      'name': '宣城市',
      'shortName': '宣城',
      'lng': '118.757995',
      'lat': '30.945667',
      'pinyin': 'Xuancheng'
    },
    {
      'pkid': '350100',
      'name': '福州市',
      'shortName': '福州',
      'lng': '119.306239',
      'lat': '26.075302',
      'pinyin': 'Fuzhou'
    },
    {
      'pkid': '350200',
      'name': '厦门市',
      'shortName': '厦门',
      'lng': '118.110220',
      'lat': '24.490474',
      'pinyin': 'Xiamen'
    },
    {
      'pkid': '350300',
      'name': '莆田市',
      'shortName': '莆田',
      'lng': '119.007558',
      'lat': '25.431011',
      'pinyin': 'Putian'
    },
    {
      'pkid': '350400',
      'name': '三明市',
      'shortName': '三明',
      'lng': '117.635001',
      'lat': '26.265444',
      'pinyin': 'Sanming'
    },
    {
      'pkid': '350500',
      'name': '泉州市',
      'shortName': '泉州',
      'lng': '118.589421',
      'lat': '24.908853',
      'pinyin': 'Quanzhou'
    },
    {
      'pkid': '350600',
      'name': '漳州市',
      'shortName': '漳州',
      'lng': '117.661801',
      'lat': '24.510897',
      'pinyin': 'Zhangzhou'
    },
    {
      'pkid': '350700',
      'name': '南平市',
      'shortName': '南平',
      'lng': '118.178459',
      'lat': '26.635627',
      'pinyin': 'Nanping'
    },
    {
      'pkid': '350800',
      'name': '龙岩市',
      'shortName': '龙岩',
      'lng': '117.029780',
      'lat': '25.091603',
      'pinyin': 'Longyan'
    },
    {
      'pkid': '350900',
      'name': '宁德市',
      'shortName': '宁德',
      'lng': '119.527082',
      'lat': '26.659240',
      'pinyin': 'Ningde'
    },
    {
      'pkid': '360100',
      'name': '南昌市',
      'shortName': '南昌',
      'lng': '115.892151',
      'lat': '28.676493',
      'pinyin': 'Nanchang'
    },
    {
      'pkid': '360200',
      'name': '景德镇市',
      'shortName': '景德镇',
      'lng': '117.214664',
      'lat': '29.292560',
      'pinyin': 'Jingdezhen'
    },
    {
      'pkid': '360300',
      'name': '萍乡市',
      'shortName': '萍乡',
      'lng': '113.852186',
      'lat': '27.622946',
      'pinyin': 'Pingxiang'
    },
    {
      'pkid': '360400',
      'name': '九江市',
      'shortName': '九江',
      'lng': '115.992811',
      'lat': '29.712034',
      'pinyin': 'Jiujiang'
    },
    {
      'pkid': '360500',
      'name': '新余市',
      'shortName': '新余',
      'lng': '114.930835',
      'lat': '27.810834',
      'pinyin': 'Xinyu'
    },
    {
      'pkid': '360600',
      'name': '鹰潭市',
      'shortName': '鹰潭',
      'lng': '117.033838',
      'lat': '28.238638',
      'pinyin': 'Yingtan'
    },
    {
      'pkid': '360700',
      'name': '赣州市',
      'shortName': '赣州',
      'lng': '114.940278',
      'lat': '25.850970',
      'pinyin': 'Ganzhou'
    },
    {
      'pkid': '360800',
      'name': '吉安市',
      'shortName': '吉安',
      'lng': '114.986373',
      'lat': '27.111699',
      'pinyin': 'Ji\'an'
    },
    {
      'pkid': '360900',
      'name': '宜春市',
      'shortName': '宜春',
      'lng': '114.391136',
      'lat': '27.804300',
      'pinyin': 'Yichun'
    },
    {
      'pkid': '361000',
      'name': '抚州市',
      'shortName': '抚州',
      'lng': '116.358351',
      'lat': '27.983850',
      'pinyin': 'Fuzhou'
    },
    {
      'pkid': '361100',
      'name': '上饶市',
      'shortName': '上饶',
      'lng': '117.971185',
      'lat': '28.444420',
      'pinyin': 'Shangrao'
    },
    {
      'pkid': '370100',
      'name': '济南市',
      'shortName': '济南',
      'lng': '117.000923',
      'lat': '36.675807',
      'pinyin': 'Jinan'
    },
    {
      'pkid': '370200',
      'name': '青岛市',
      'shortName': '青岛',
      'lng': '120.355173',
      'lat': '36.082982',
      'pinyin': 'Qingdao'
    },
    {
      'pkid': '370300',
      'name': '淄博市',
      'shortName': '淄博',
      'lng': '118.047648',
      'lat': '36.814939',
      'pinyin': 'Zibo'
    },
    {
      'pkid': '370400',
      'name': '枣庄市',
      'shortName': '枣庄',
      'lng': '117.557964',
      'lat': '34.856424',
      'pinyin': 'Zaozhuang'
    },
    {
      'pkid': '370500',
      'name': '东营市',
      'shortName': '东营',
      'lng': '118.664710',
      'lat': '37.434564',
      'pinyin': 'Dongying'
    },
    {
      'pkid': '370600',
      'name': '烟台市',
      'shortName': '烟台',
      'lng': '121.391382',
      'lat': '37.539297',
      'pinyin': 'Yantai'
    },
    {
      'pkid': '370700',
      'name': '潍坊市',
      'shortName': '潍坊',
      'lng': '119.107078',
      'lat': '36.709250',
      'pinyin': 'Weifang'
    },
    {
      'pkid': '370800',
      'name': '济宁市',
      'shortName': '济宁',
      'lng': '116.587245',
      'lat': '35.415393',
      'pinyin': 'Jining'
    },
    {
      'pkid': '370900',
      'name': '泰安市',
      'shortName': '泰安',
      'lng': '117.129063',
      'lat': '36.194968',
      'pinyin': 'Tai\'an'
    },
    {
      'pkid': '371000',
      'name': '威海市',
      'shortName': '威海',
      'lng': '122.116394',
      'lat': '37.509691',
      'pinyin': 'Weihai'
    },
    {
      'pkid': '371100',
      'name': '日照市',
      'shortName': '日照',
      'lng': '119.461208',
      'lat': '35.428588',
      'pinyin': 'Rizhao'
    },
    {
      'pkid': '371200',
      'name': '莱芜市',
      'shortName': '莱芜',
      'lng': '117.677736',
      'lat': '36.214397',
      'pinyin': 'Laiwu'
    },
    {
      'pkid': '371300',
      'name': '临沂市',
      'shortName': '临沂',
      'lng': '118.326443',
      'lat': '35.065282',
      'pinyin': 'Linyi'
    },
    {
      'pkid': '371400',
      'name': '德州市',
      'shortName': '德州',
      'lng': '116.307428',
      'lat': '37.453968',
      'pinyin': 'Dezhou'
    },
    {
      'pkid': '371500',
      'name': '聊城市',
      'shortName': '聊城',
      'lng': '115.980367',
      'lat': '36.456013',
      'pinyin': 'Liaocheng'
    },
    {
      'pkid': '371600',
      'name': '滨州市',
      'shortName': '滨州',
      'lng': '118.016974',
      'lat': '37.383542',
      'pinyin': 'Binzhou'
    },
    {
      'pkid': '371700',
      'name': '菏泽市',
      'shortName': '菏泽',
      'lng': '115.469381',
      'lat': '35.246531',
      'pinyin': 'Heze'
    },
    {
      'pkid': '410100',
      'name': '郑州市',
      'shortName': '郑州',
      'lng': '113.665412',
      'lat': '34.757975',
      'pinyin': 'Zhengzhou'
    },
    {
      'pkid': '410200',
      'name': '开封市',
      'shortName': '开封',
      'lng': '114.341447',
      'lat': '34.797049',
      'pinyin': 'Kaifeng'
    },
    {
      'pkid': '410300',
      'name': '洛阳市',
      'shortName': '洛阳',
      'lng': '112.434468',
      'lat': '34.663041',
      'pinyin': 'Luoyang'
    },
    {
      'pkid': '410400',
      'name': '平顶山市',
      'shortName': '平顶山',
      'lng': '113.307718',
      'lat': '33.735241',
      'pinyin': 'Pingdingshan'
    },
    {
      'pkid': '410500',
      'name': '安阳市',
      'shortName': '安阳',
      'lng': '114.352482',
      'lat': '36.103442',
      'pinyin': 'Anyang'
    },
    {
      'pkid': '410600',
      'name': '鹤壁市',
      'shortName': '鹤壁',
      'lng': '114.295444',
      'lat': '35.748236',
      'pinyin': 'Hebi'
    },
    {
      'pkid': '410700',
      'name': '新乡市',
      'shortName': '新乡',
      'lng': '113.883991',
      'lat': '35.302616',
      'pinyin': 'Xinxiang'
    },
    {
      'pkid': '410800',
      'name': '焦作市',
      'shortName': '焦作',
      'lng': '113.238266',
      'lat': '35.239040',
      'pinyin': 'Jiaozuo'
    },
    {
      'pkid': '410900',
      'name': '濮阳市',
      'shortName': '濮阳',
      'lng': '115.041299',
      'lat': '35.768234',
      'pinyin': 'Puyang'
    },
    {
      'pkid': '411000',
      'name': '许昌市',
      'shortName': '许昌',
      'lng': '113.826063',
      'lat': '34.022956',
      'pinyin': 'Xuchang'
    },
    {
      'pkid': '411100',
      'name': '漯河市',
      'shortName': '漯河',
      'lng': '114.026405',
      'lat': '33.575855',
      'pinyin': 'Luohe'
    },
    {
      'pkid': '411200',
      'name': '三门峡市',
      'shortName': '三门峡',
      'lng': '111.194099',
      'lat': '34.777338',
      'pinyin': 'Sanmenxia'
    },
    {
      'pkid': '411300',
      'name': '南阳市',
      'shortName': '南阳',
      'lng': '112.540918',
      'lat': '32.999082',
      'pinyin': 'Nanyang'
    },
    {
      'pkid': '411400',
      'name': '商丘市',
      'shortName': '商丘',
      'lng': '115.650497',
      'lat': '34.437054',
      'pinyin': 'Shangqiu'
    },
    {
      'pkid': '411500',
      'name': '信阳市',
      'shortName': '信阳',
      'lng': '114.075031',
      'lat': '32.123274',
      'pinyin': 'Xinyang'
    },
    {
      'pkid': '411600',
      'name': '周口市',
      'shortName': '周口',
      'lng': '114.649653',
      'lat': '33.620357',
      'pinyin': 'Zhoukou'
    },
    {
      'pkid': '411700',
      'name': '驻马店市',
      'shortName': '驻马店',
      'lng': '114.024736',
      'lat': '32.980169',
      'pinyin': 'Zhumadian'
    },
    {
      'pkid': '419000',
      'name': '直辖县级',
      'shortName': ' ',
      'lng': '113.665412',
      'lat': '34.757975',
      'pinyin': ''
    },
    {
      'pkid': '420100',
      'name': '武汉市',
      'shortName': '武汉',
      'lng': '114.298572',
      'lat': '30.584355',
      'pinyin': 'Wuhan'
    },
    {
      'pkid': '420200',
      'name': '黄石市',
      'shortName': '黄石',
      'lng': '115.077048',
      'lat': '30.220074',
      'pinyin': 'Huangshi'
    },
    {
      'pkid': '420300',
      'name': '十堰市',
      'shortName': '十堰',
      'lng': '110.787916',
      'lat': '32.646907',
      'pinyin': 'Shiyan'
    },
    {
      'pkid': '420500',
      'name': '宜昌市',
      'shortName': '宜昌',
      'lng': '111.290843',
      'lat': '30.702636',
      'pinyin': 'Yichang'
    },
    {
      'pkid': '420600',
      'name': '襄阳市',
      'shortName': '襄阳',
      'lng': '112.144146',
      'lat': '32.042426',
      'pinyin': 'Xiangyang'
    },
    {
      'pkid': '420700',
      'name': '鄂州市',
      'shortName': '鄂州',
      'lng': '114.890593',
      'lat': '30.396536',
      'pinyin': 'Ezhou'
    },
    {
      'pkid': '420800',
      'name': '荆门市',
      'shortName': '荆门',
      'lng': '112.204251',
      'lat': '31.035420',
      'pinyin': 'Jingmen'
    },
    {
      'pkid': '420900',
      'name': '孝感市',
      'shortName': '孝感',
      'lng': '113.926655',
      'lat': '30.926423',
      'pinyin': 'Xiaogan'
    },
    {
      'pkid': '421000',
      'name': '荆州市',
      'shortName': '荆州',
      'lng': '112.238130',
      'lat': '30.326857',
      'pinyin': 'Jingzhou'
    },
    {
      'pkid': '421100',
      'name': '黄冈市',
      'shortName': '黄冈',
      'lng': '114.879365',
      'lat': '30.447711',
      'pinyin': 'Huanggang'
    },
    {
      'pkid': '421200',
      'name': '咸宁市',
      'shortName': '咸宁',
      'lng': '114.328963',
      'lat': '29.832798',
      'pinyin': 'Xianning'
    },
    {
      'pkid': '421300',
      'name': '随州市',
      'shortName': '随州',
      'lng': '113.373770',
      'lat': '31.717497',
      'pinyin': 'Suizhou'
    },
    {
      'pkid': '422800',
      'name': '恩施土家族苗族自治州',
      'shortName': '恩施',
      'lng': '109.486990',
      'lat': '30.283114',
      'pinyin': 'Enshi'
    },
    {
      'pkid': '429000',
      'name': '直辖县级',
      'shortName': ' ',
      'lng': '114.298572',
      'lat': '30.584355',
      'pinyin': ''
    },
    {
      'pkid': '430100',
      'name': '长沙市',
      'shortName': '长沙',
      'lng': '112.982279',
      'lat': '28.194090',
      'pinyin': 'Changsha'
    },
    {
      'pkid': '430200',
      'name': '株洲市',
      'shortName': '株洲',
      'lng': '113.151737',
      'lat': '27.835806',
      'pinyin': 'Zhuzhou'
    },
    {
      'pkid': '430300',
      'name': '湘潭市',
      'shortName': '湘潭',
      'lng': '112.944052',
      'lat': '27.829730',
      'pinyin': 'Xiangtan'
    },
    {
      'pkid': '430400',
      'name': '衡阳市',
      'shortName': '衡阳',
      'lng': '112.607693',
      'lat': '26.900358',
      'pinyin': 'Hengyang'
    },
    {
      'pkid': '430500',
      'name': '邵阳市',
      'shortName': '邵阳',
      'lng': '111.469230',
      'lat': '27.237842',
      'pinyin': 'Shaoyang'
    },
    {
      'pkid': '430600',
      'name': '岳阳市',
      'shortName': '岳阳',
      'lng': '113.132855',
      'lat': '29.370290',
      'pinyin': 'Yueyang'
    },
    {
      'pkid': '430700',
      'name': '常德市',
      'shortName': '常德',
      'lng': '111.691347',
      'lat': '29.040225',
      'pinyin': 'Changde'
    },
    {
      'pkid': '430800',
      'name': '张家界市',
      'shortName': '张家界',
      'lng': '110.479921',
      'lat': '29.127401',
      'pinyin': 'Zhangjiajie'
    },
    {
      'pkid': '430900',
      'name': '益阳市',
      'shortName': '益阳',
      'lng': '112.355042',
      'lat': '28.570066',
      'pinyin': 'Yiyang'
    },
    {
      'pkid': '431000',
      'name': '郴州市',
      'shortName': '郴州',
      'lng': '113.032067',
      'lat': '25.793589',
      'pinyin': 'Chenzhou'
    },
    {
      'pkid': '431100',
      'name': '永州市',
      'shortName': '永州',
      'lng': '111.608019',
      'lat': '26.434516',
      'pinyin': 'Yongzhou'
    },
    {
      'pkid': '431200',
      'name': '怀化市',
      'shortName': '怀化',
      'lng': '109.978240',
      'lat': '27.550082',
      'pinyin': 'Huaihua'
    },
    {
      'pkid': '431300',
      'name': '娄底市',
      'shortName': '娄底',
      'lng': '112.008497',
      'lat': '27.728136',
      'pinyin': 'Loudi'
    },
    {
      'pkid': '433100',
      'name': '湘西土家族苗族自治州',
      'shortName': '湘西',
      'lng': '109.739735',
      'lat': '28.314296',
      'pinyin': 'Xiangxi'
    },
    {
      'pkid': '440100',
      'name': '广州市',
      'shortName': '广州',
      'lng': '113.280637',
      'lat': '23.125178',
      'pinyin': 'Guangzhou'
    },
    {
      'pkid': '440200',
      'name': '韶关市',
      'shortName': '韶关',
      'lng': '113.591544',
      'lat': '24.801322',
      'pinyin': 'Shaoguan'
    },
    {
      'pkid': '440300',
      'name': '深圳市',
      'shortName': '深圳',
      'lng': '114.085947',
      'lat': '22.547000',
      'pinyin': 'Shenzhen'
    },
    {
      'pkid': '440400',
      'name': '珠海市',
      'shortName': '珠海',
      'lng': '113.553986',
      'lat': '22.224979',
      'pinyin': 'Zhuhai'
    },
    {
      'pkid': '440500',
      'name': '汕头市',
      'shortName': '汕头',
      'lng': '116.708463',
      'lat': '23.371020',
      'pinyin': 'Shantou'
    },
    {
      'pkid': '440600',
      'name': '佛山市',
      'shortName': '佛山',
      'lng': '113.122717',
      'lat': '23.028762',
      'pinyin': 'Foshan'
    },
    {
      'pkid': '440700',
      'name': '江门市',
      'shortName': '江门',
      'lng': '113.094942',
      'lat': '22.590431',
      'pinyin': 'Jiangmen'
    },
    {
      'pkid': '440800',
      'name': '湛江市',
      'shortName': '湛江',
      'lng': '110.364977',
      'lat': '21.274898',
      'pinyin': 'Zhanjiang'
    },
    {
      'pkid': '440900',
      'name': '茂名市',
      'shortName': '茂名',
      'lng': '110.919229',
      'lat': '21.659751',
      'pinyin': 'Maoming'
    },
    {
      'pkid': '441200',
      'name': '肇庆市',
      'shortName': '肇庆',
      'lng': '112.472529',
      'lat': '23.051546',
      'pinyin': 'Zhaoqing'
    },
    {
      'pkid': '441300',
      'name': '惠州市',
      'shortName': '惠州',
      'lng': '114.412599',
      'lat': '23.079404',
      'pinyin': 'Huizhou'
    },
    {
      'pkid': '441400',
      'name': '梅州市',
      'shortName': '梅州',
      'lng': '116.117582',
      'lat': '24.299112',
      'pinyin': 'Meizhou'
    },
    {
      'pkid': '441500',
      'name': '汕尾市',
      'shortName': '汕尾',
      'lng': '115.364238',
      'lat': '22.774485',
      'pinyin': 'Shanwei'
    },
    {
      'pkid': '441600',
      'name': '河源市',
      'shortName': '河源',
      'lng': '114.697802',
      'lat': '23.746266',
      'pinyin': 'Heyuan'
    },
    {
      'pkid': '441700',
      'name': '阳江市',
      'shortName': '阳江',
      'lng': '111.975107',
      'lat': '21.859222',
      'pinyin': 'Yangjiang'
    },
    {
      'pkid': '441800',
      'name': '清远市',
      'shortName': '清远',
      'lng': '113.051227',
      'lat': '23.685022',
      'pinyin': 'Qingyuan'
    },
    {
      'pkid': '441900',
      'name': '东莞市',
      'shortName': '东莞',
      'lng': '113.740978',
      'lat': '23.009399',
      'pinyin': 'Dongguan'
    },
    {
      'pkid': '442000',
      'name': '中山市',
      'shortName': '中山',
      'lng': '113.382618',
      'lat': '22.542919',
      'pinyin': 'Zhongshan'
    },
    {
      'pkid': '445100',
      'name': '潮州市',
      'shortName': '潮州',
      'lng': '116.632301',
      'lat': '23.661701',
      'pinyin': 'Chaozhou'
    },
    {
      'pkid': '445200',
      'name': '揭阳市',
      'shortName': '揭阳',
      'lng': '116.355733',
      'lat': '23.543778',
      'pinyin': 'Jieyang'
    },
    {
      'pkid': '445300',
      'name': '云浮市',
      'shortName': '云浮',
      'lng': '112.044439',
      'lat': '22.929801',
      'pinyin': 'Yunfu'
    },
    {
      'pkid': '450100',
      'name': '南宁市',
      'shortName': '南宁',
      'lng': '108.320004',
      'lat': '22.824020',
      'pinyin': 'Nanning'
    },
    {
      'pkid': '450200',
      'name': '柳州市',
      'shortName': '柳州',
      'lng': '109.411703',
      'lat': '24.314617',
      'pinyin': 'Liuzhou'
    },
    {
      'pkid': '450300',
      'name': '桂林市',
      'shortName': '桂林',
      'lng': '110.299121',
      'lat': '25.274215',
      'pinyin': 'Guilin'
    },
    {
      'pkid': '450400',
      'name': '梧州市',
      'shortName': '梧州',
      'lng': '111.297604',
      'lat': '23.474803',
      'pinyin': 'Wuzhou'
    },
    {
      'pkid': '450500',
      'name': '北海市',
      'shortName': '北海',
      'lng': '109.119254',
      'lat': '21.473343',
      'pinyin': 'Beihai'
    },
    {
      'pkid': '450600',
      'name': '防城港市',
      'shortName': '防城港',
      'lng': '108.345478',
      'lat': '21.614631',
      'pinyin': 'Fangchenggang'
    },
    {
      'pkid': '450700',
      'name': '钦州市',
      'shortName': '钦州',
      'lng': '108.624175',
      'lat': '21.967127',
      'pinyin': 'Qinzhou'
    },
    {
      'pkid': '450800',
      'name': '贵港市',
      'shortName': '贵港',
      'lng': '109.602146',
      'lat': '23.093600',
      'pinyin': 'Guigang'
    },
    {
      'pkid': '450900',
      'name': '玉林市',
      'shortName': '玉林',
      'lng': '110.154393',
      'lat': '22.631360',
      'pinyin': 'Yulin'
    },
    {
      'pkid': '451000',
      'name': '百色市',
      'shortName': '百色',
      'lng': '106.616285',
      'lat': '23.897742',
      'pinyin': 'Baise'
    },
    {
      'pkid': '451100',
      'name': '贺州市',
      'shortName': '贺州',
      'lng': '111.552056',
      'lat': '24.414141',
      'pinyin': 'Hezhou'
    },
    {
      'pkid': '451200',
      'name': '河池市',
      'shortName': '河池',
      'lng': '108.062105',
      'lat': '24.695899',
      'pinyin': 'Hechi'
    },
    {
      'pkid': '451300',
      'name': '来宾市',
      'shortName': '来宾',
      'lng': '109.229772',
      'lat': '23.733766',
      'pinyin': 'Laibin'
    },
    {
      'pkid': '451400',
      'name': '崇左市',
      'shortName': '崇左',
      'lng': '107.353926',
      'lat': '22.404108',
      'pinyin': 'Chongzuo'
    },
    {
      'pkid': '460100',
      'name': '海口市',
      'shortName': '海口',
      'lng': '110.331190',
      'lat': '20.031971',
      'pinyin': 'Haikou'
    },
    {
      'pkid': '460300',
      'name': '三沙市',
      'shortName': '三沙',
      'lng': '112.348820',
      'lat': '16.831039',
      'pinyin': 'Sansha'
    },
    {
      'pkid': '469000',
      'name': '直辖县级',
      'shortName': ' ',
      'lng': '109.503479',
      'lat': '18.739906',
      'pinyin': ''
    },
    {
      'pkid': '500100',
      'name': '重庆市市辖区',
      'shortName': '重庆',
      'lng': '106.504962',
      'lat': '29.533155',
      'pinyin': 'Chongqing'
    },
    {
      'pkid': '500300',
      'name': '两江新区',
      'shortName': '两江新区',
      'lng': '106.463344',
      'lat': '29.729153',
      'pinyin': 'Liangjiangxinqu'
    },
    {
      'pkid': '510100',
      'name': '成都市',
      'shortName': '成都',
      'lng': '104.065735',
      'lat': '30.659462',
      'pinyin': 'Chengdu'
    },
    {
      'pkid': '510300',
      'name': '自贡市',
      'shortName': '自贡',
      'lng': '104.773447',
      'lat': '29.352765',
      'pinyin': 'Zigong'
    },
    {
      'pkid': '510400',
      'name': '攀枝花市',
      'shortName': '攀枝花',
      'lng': '101.716007',
      'lat': '26.580446',
      'pinyin': 'Panzhihua'
    },
    {
      'pkid': '510500',
      'name': '泸州市',
      'shortName': '泸州',
      'lng': '105.443348',
      'lat': '28.889138',
      'pinyin': 'Luzhou'
    },
    {
      'pkid': '510600',
      'name': '德阳市',
      'shortName': '德阳',
      'lng': '104.398651',
      'lat': '31.127991',
      'pinyin': 'Deyang'
    },
    {
      'pkid': '510700',
      'name': '绵阳市',
      'shortName': '绵阳',
      'lng': '104.741722',
      'lat': '31.464020',
      'pinyin': 'Mianyang'
    },
    {
      'pkid': '510800',
      'name': '广元市',
      'shortName': '广元',
      'lng': '105.829757',
      'lat': '32.433668',
      'pinyin': 'Guangyuan'
    },
    {
      'pkid': '510900',
      'name': '遂宁市',
      'shortName': '遂宁',
      'lng': '105.571331',
      'lat': '30.513311',
      'pinyin': 'Suining'
    },
    {
      'pkid': '511000',
      'name': '内江市',
      'shortName': '内江',
      'lng': '105.066138',
      'lat': '29.587080',
      'pinyin': 'Neijiang'
    },
    {
      'pkid': '511100',
      'name': '乐山市',
      'shortName': '乐山',
      'lng': '103.761263',
      'lat': '29.582024',
      'pinyin': 'Leshan'
    },
    {
      'pkid': '511300',
      'name': '南充市',
      'shortName': '南充',
      'lng': '106.082974',
      'lat': '30.795281',
      'pinyin': 'Nanchong'
    },
    {
      'pkid': '511400',
      'name': '眉山市',
      'shortName': '眉山',
      'lng': '103.831788',
      'lat': '30.048318',
      'pinyin': 'Meishan'
    },
    {
      'pkid': '511500',
      'name': '宜宾市',
      'shortName': '宜宾',
      'lng': '104.630825',
      'lat': '28.760189',
      'pinyin': 'Yibin'
    },
    {
      'pkid': '511600',
      'name': '广安市',
      'shortName': '广安',
      'lng': '106.633369',
      'lat': '30.456398',
      'pinyin': 'Guang\'an'
    },
    {
      'pkid': '511700',
      'name': '达州市',
      'shortName': '达州',
      'lng': '107.502262',
      'lat': '31.209484',
      'pinyin': 'Dazhou'
    },
    {
      'pkid': '511800',
      'name': '雅安市',
      'shortName': '雅安',
      'lng': '103.001033',
      'lat': '29.987722',
      'pinyin': 'Ya\'an'
    },
    {
      'pkid': '511900',
      'name': '巴中市',
      'shortName': '巴中',
      'lng': '106.753669',
      'lat': '31.858809',
      'pinyin': 'Bazhong'
    },
    {
      'pkid': '512000',
      'name': '资阳市',
      'shortName': '资阳',
      'lng': '104.641917',
      'lat': '30.122211',
      'pinyin': 'Ziyang'
    },
    {
      'pkid': '513200',
      'name': '阿坝藏族羌族自治州',
      'shortName': '阿坝',
      'lng': '102.221374',
      'lat': '31.899792',
      'pinyin': 'Aba'
    },
    {
      'pkid': '513300',
      'name': '甘孜藏族自治州',
      'shortName': '甘孜',
      'lng': '101.963815',
      'lat': '30.050663',
      'pinyin': 'Garze'
    },
    {
      'pkid': '513400',
      'name': '凉山彝族自治州',
      'shortName': '凉山',
      'lng': '102.258746',
      'lat': '27.886762',
      'pinyin': 'Liangshan'
    },
    {
      'pkid': '520100',
      'name': '贵阳市',
      'shortName': '贵阳',
      'lng': '106.713478',
      'lat': '26.578343',
      'pinyin': 'Guiyang'
    },
    {
      'pkid': '520200',
      'name': '六盘水市',
      'shortName': '六盘水',
      'lng': '104.846743',
      'lat': '26.584643',
      'pinyin': 'Liupanshui'
    },
    {
      'pkid': '520300',
      'name': '遵义市',
      'shortName': '遵义',
      'lng': '106.937265',
      'lat': '27.706626',
      'pinyin': 'Zunyi'
    },
    {
      'pkid': '520400',
      'name': '安顺市',
      'shortName': '安顺',
      'lng': '105.932188',
      'lat': '26.245544',
      'pinyin': 'Anshun'
    },
    {
      'pkid': '520500',
      'name': '毕节市',
      'shortName': '毕节',
      'lng': '105.285010',
      'lat': '27.301693',
      'pinyin': 'Bijie'
    },
    {
      'pkid': '520600',
      'name': '铜仁市',
      'shortName': '铜仁',
      'lng': '109.191555',
      'lat': '27.718346',
      'pinyin': 'Tongren'
    },
    {
      'pkid': '522300',
      'name': '黔西南布依族苗族自治州',
      'shortName': '黔西南',
      'lng': '104.897971',
      'lat': '25.088120',
      'pinyin': 'Qianxinan'
    },
    {
      'pkid': '522600',
      'name': '黔东南苗族侗族自治州',
      'shortName': '黔东南',
      'lng': '107.977488',
      'lat': '26.583352',
      'pinyin': 'Qiandongnan'
    },
    {
      'pkid': '522700',
      'name': '黔南布依族苗族自治州',
      'shortName': '黔南',
      'lng': '107.517156',
      'lat': '26.258219',
      'pinyin': 'Qiannan'
    },
    {
      'pkid': '530100',
      'name': '昆明市',
      'shortName': '昆明',
      'lng': '102.712251',
      'lat': '25.040609',
      'pinyin': 'Kunming'
    },
    {
      'pkid': '530300',
      'name': '曲靖市',
      'shortName': '曲靖',
      'lng': '103.797851',
      'lat': '25.501557',
      'pinyin': 'Qujing'
    },
    {
      'pkid': '530400',
      'name': '玉溪市',
      'shortName': '玉溪',
      'lng': '102.543907',
      'lat': '24.350461',
      'pinyin': 'Yuxi'
    },
    {
      'pkid': '530500',
      'name': '保山市',
      'shortName': '保山',
      'lng': '99.167133',
      'lat': '25.111802',
      'pinyin': 'Baoshan'
    },
    {
      'pkid': '530600',
      'name': '昭通市',
      'shortName': '昭通',
      'lng': '103.717216',
      'lat': '27.336999',
      'pinyin': 'Zhaotong'
    },
    {
      'pkid': '530700',
      'name': '丽江市',
      'shortName': '丽江',
      'lng': '100.233026',
      'lat': '26.872108',
      'pinyin': 'Lijiang'
    },
    {
      'pkid': '530800',
      'name': '普洱市',
      'shortName': '普洱',
      'lng': '100.972344',
      'lat': '22.777321',
      'pinyin': 'Pu\'er'
    },
    {
      'pkid': '530900',
      'name': '临沧市',
      'shortName': '临沧',
      'lng': '100.086970',
      'lat': '23.886567',
      'pinyin': 'Lincang'
    },
    {
      'pkid': '532300',
      'name': '楚雄彝族自治州',
      'shortName': '楚雄',
      'lng': '101.546046',
      'lat': '25.041988',
      'pinyin': 'Chuxiong'
    },
    {
      'pkid': '532500',
      'name': '红河哈尼族彝族自治州',
      'shortName': '红河',
      'lng': '103.384182',
      'lat': '23.366775',
      'pinyin': 'Honghe'
    },
    {
      'pkid': '532600',
      'name': '文山壮族苗族自治州',
      'shortName': '文山',
      'lng': '104.244010',
      'lat': '23.369510',
      'pinyin': 'Wenshan'
    },
    {
      'pkid': '532800',
      'name': '西双版纳傣族自治州',
      'shortName': '西双版纳',
      'lng': '100.797941',
      'lat': '22.001724',
      'pinyin': 'Xishuangbanna'
    },
    {
      'pkid': '532900',
      'name': '大理白族自治州',
      'shortName': '大理',
      'lng': '100.225668',
      'lat': '25.589449',
      'pinyin': 'Dali'
    },
    {
      'pkid': '533100',
      'name': '德宏傣族景颇族自治州',
      'shortName': '德宏',
      'lng': '98.578363',
      'lat': '24.436694',
      'pinyin': 'Dehong'
    },
    {
      'pkid': '533300',
      'name': '怒江傈僳族自治州',
      'shortName': '怒江',
      'lng': '98.854304',
      'lat': '25.850949',
      'pinyin': 'Nujiang'
    },
    {
      'pkid': '533400',
      'name': '迪庆藏族自治州',
      'shortName': '迪庆',
      'lng': '99.706463',
      'lat': '27.826853',
      'pinyin': 'Deqen'
    },
    {
      'pkid': '540100',
      'name': '拉萨市',
      'shortName': '拉萨',
      'lng': '91.132212',
      'lat': '29.660361',
      'pinyin': 'Lhasa'
    },
    {
      'pkid': '540200',
      'name': '日喀则市',
      'shortName': '日喀则',
      'lng': '88.885148',
      'lat': '29.267519',
      'pinyin': 'Rikaze'
    },
    {
      'pkid': '540300',
      'name': '昌都市',
      'shortName': '昌都',
      'lng': '97.178452',
      'lat': '31.136875',
      'pinyin': 'Qamdo'
    },
    {
      'pkid': '542200',
      'name': '山南市',
      'shortName': '山南',
      'lng': '91.766529',
      'lat': '29.236023',
      'pinyin': 'Shannan'
    },
    {
      'pkid': '542400',
      'name': '那曲地区',
      'shortName': '那曲',
      'lng': '92.060214',
      'lat': '31.476004',
      'pinyin': 'Nagqu'
    },
    {
      'pkid': '542500',
      'name': '阿里地区',
      'shortName': '阿里',
      'lng': '80.105498',
      'lat': '32.503187',
      'pinyin': 'Ngari'
    },
    {
      'pkid': '542600',
      'name': '林芝地区',
      'shortName': '林芝',
      'lng': '94.362348',
      'lat': '29.654693',
      'pinyin': 'Nyingchi'
    },
    {
      'pkid': '610100',
      'name': '西安市',
      'shortName': '西安',
      'lng': '108.948024',
      'lat': '34.263161',
      'pinyin': 'Xi\'an'
    },
    {
      'pkid': '610200',
      'name': '铜川市',
      'shortName': '铜川',
      'lng': '108.979608',
      'lat': '34.916582',
      'pinyin': 'Tongchuan'
    },
    {
      'pkid': '610300',
      'name': '宝鸡市',
      'shortName': '宝鸡',
      'lng': '107.144870',
      'lat': '34.369315',
      'pinyin': 'Baoji'
    },
    {
      'pkid': '610400',
      'name': '咸阳市',
      'shortName': '咸阳',
      'lng': '108.705117',
      'lat': '34.333439',
      'pinyin': 'Xianyang'
    },
    {
      'pkid': '610500',
      'name': '渭南市',
      'shortName': '渭南',
      'lng': '109.502882',
      'lat': '34.499381',
      'pinyin': 'Weinan'
    },
    {
      'pkid': '610600',
      'name': '延安市',
      'shortName': '延安',
      'lng': '109.490810',
      'lat': '36.596537',
      'pinyin': 'Yan\'an'
    },
    {
      'pkid': '610700',
      'name': '汉中市',
      'shortName': '汉中',
      'lng': '107.028621',
      'lat': '33.077668',
      'pinyin': 'Hanzhong'
    },
    {
      'pkid': '610800',
      'name': '榆林市',
      'shortName': '榆林',
      'lng': '109.741193',
      'lat': '38.290162',
      'pinyin': 'Yulin'
    },
    {
      'pkid': '610900',
      'name': '安康市',
      'shortName': '安康',
      'lng': '109.029273',
      'lat': '32.690300',
      'pinyin': 'Ankang'
    },
    {
      'pkid': '611000',
      'name': '商洛市',
      'shortName': '商洛',
      'lng': '109.939776',
      'lat': '33.868319',
      'pinyin': 'Shangluo'
    },
    {
      'pkid': '611100',
      'name': '西咸新区',
      'shortName': '西咸',
      'lng': '108.810654',
      'lat': '34.307144',
      'pinyin': 'Xixian'
    },
    {
      'pkid': '620100',
      'name': '兰州市',
      'shortName': '兰州',
      'lng': '103.823557',
      'lat': '36.058039',
      'pinyin': 'Lanzhou'
    },
    {
      'pkid': '620200',
      'name': '嘉峪关市',
      'shortName': '嘉峪关',
      'lng': '98.277304',
      'lat': '39.786529',
      'pinyin': 'Jiayuguan'
    },
    {
      'pkid': '620300',
      'name': '金昌市',
      'shortName': '金昌',
      'lng': '102.187888',
      'lat': '38.514238',
      'pinyin': 'Jinchang'
    },
    {
      'pkid': '620400',
      'name': '白银市',
      'shortName': '白银',
      'lng': '104.173606',
      'lat': '36.545680',
      'pinyin': 'Baiyin'
    },
    {
      'pkid': '620500',
      'name': '天水市',
      'shortName': '天水',
      'lng': '105.724998',
      'lat': '34.578529',
      'pinyin': 'Tianshui'
    },
    {
      'pkid': '620600',
      'name': '武威市',
      'shortName': '武威',
      'lng': '102.634697',
      'lat': '37.929996',
      'pinyin': 'Wuwei'
    },
    {
      'pkid': '620700',
      'name': '张掖市',
      'shortName': '张掖',
      'lng': '100.455472',
      'lat': '38.932897',
      'pinyin': 'Zhangye'
    },
    {
      'pkid': '620800',
      'name': '平凉市',
      'shortName': '平凉',
      'lng': '106.684691',
      'lat': '35.542790',
      'pinyin': 'Pingliang'
    },
    {
      'pkid': '620900',
      'name': '酒泉市',
      'shortName': '酒泉',
      'lng': '98.510795',
      'lat': '39.744023',
      'pinyin': 'Jiuquan'
    },
    {
      'pkid': '621000',
      'name': '庆阳市',
      'shortName': '庆阳',
      'lng': '107.638372',
      'lat': '35.734218',
      'pinyin': 'Qingyang'
    },
    {
      'pkid': '621100',
      'name': '定西市',
      'shortName': '定西',
      'lng': '104.626294',
      'lat': '35.579578',
      'pinyin': 'Dingxi'
    },
    {
      'pkid': '621200',
      'name': '陇南市',
      'shortName': '陇南',
      'lng': '104.929379',
      'lat': '33.388598',
      'pinyin': 'Longnan'
    },
    {
      'pkid': '622900',
      'name': '临夏回族自治州',
      'shortName': '临夏',
      'lng': '103.212006',
      'lat': '35.599446',
      'pinyin': 'Linxia'
    },
    {
      'pkid': '623000',
      'name': '甘南藏族自治州',
      'shortName': '甘南',
      'lng': '102.911008',
      'lat': '34.986354',
      'pinyin': 'Gannan'
    },
    {
      'pkid': '630100',
      'name': '西宁市',
      'shortName': '西宁',
      'lng': '101.778916',
      'lat': '36.623178',
      'pinyin': 'Xining'
    },
    {
      'pkid': '630200',
      'name': '海东市',
      'shortName': '海东',
      'lng': '102.103270',
      'lat': '36.502916',
      'pinyin': 'Haidong'
    },
    {
      'pkid': '632200',
      'name': '海北藏族自治州',
      'shortName': '海北',
      'lng': '100.901059',
      'lat': '36.959435',
      'pinyin': 'Haibei'
    },
    {
      'pkid': '632300',
      'name': '黄南藏族自治州',
      'shortName': '黄南',
      'lng': '102.019988',
      'lat': '35.517744',
      'pinyin': 'Huangnan'
    },
    {
      'pkid': '632500',
      'name': '海南藏族自治州',
      'shortName': '海南',
      'lng': '100.619542',
      'lat': '36.280353',
      'pinyin': 'Hainan'
    },
    {
      'pkid': '632600',
      'name': '果洛藏族自治州',
      'shortName': '果洛',
      'lng': '100.242143',
      'lat': '34.473600',
      'pinyin': 'Golog'
    },
    {
      'pkid': '632700',
      'name': '玉树藏族自治州',
      'shortName': '玉树',
      'lng': '97.008522',
      'lat': '33.004049',
      'pinyin': 'Yushu'
    },
    {
      'pkid': '632800',
      'name': '海西蒙古族藏族自治州',
      'shortName': '海西',
      'lng': '97.370785',
      'lat': '37.374663',
      'pinyin': 'Haixi'
    },
    {
      'pkid': '640100',
      'name': '银川市',
      'shortName': '银川',
      'lng': '106.278179',
      'lat': '38.466370',
      'pinyin': 'Yinchuan'
    },
    {
      'pkid': '640200',
      'name': '石嘴山市',
      'shortName': '石嘴山',
      'lng': '106.376173',
      'lat': '39.013330',
      'pinyin': 'Shizuishan'
    },
    {
      'pkid': '640300',
      'name': '吴忠市',
      'shortName': '吴忠',
      'lng': '106.199409',
      'lat': '37.986165',
      'pinyin': 'Wuzhong'
    },
    {
      'pkid': '640400',
      'name': '固原市',
      'shortName': '固原',
      'lng': '106.285241',
      'lat': '36.004561',
      'pinyin': 'Guyuan'
    },
    {
      'pkid': '640500',
      'name': '中卫市',
      'shortName': '中卫',
      'lng': '105.189568',
      'lat': '37.514951',
      'pinyin': 'Zhongwei'
    },
    {
      'pkid': '650100',
      'name': '乌鲁木齐市',
      'shortName': '乌鲁木齐',
      'lng': '87.617733',
      'lat': '43.792818',
      'pinyin': 'Urumqi'
    },
    {
      'pkid': '650200',
      'name': '克拉玛依市',
      'shortName': '克拉玛依',
      'lng': '84.873946',
      'lat': '45.595886',
      'pinyin': 'Karamay'
    },
    {
      'pkid': '652100',
      'name': '吐鲁番地区',
      'shortName': '吐鲁番',
      'lng': '89.184078',
      'lat': '42.947613',
      'pinyin': 'Turpan'
    },
    {
      'pkid': '652200',
      'name': '哈密市',
      'shortName': '哈密',
      'lng': '93.513160',
      'lat': '42.833248',
      'pinyin': 'Hami'
    },
    {
      'pkid': '652300',
      'name': '昌吉回族自治州',
      'shortName': '昌吉',
      'lng': '87.304012',
      'lat': '44.014577',
      'pinyin': 'Changji'
    },
    {
      'pkid': '652700',
      'name': '博尔塔拉蒙古自治州',
      'shortName': '博尔塔拉',
      'lng': '82.074778',
      'lat': '44.903258',
      'pinyin': 'Bortala'
    },
    {
      'pkid': '652800',
      'name': '巴音郭楞蒙古自治州',
      'shortName': '巴音郭楞',
      'lng': '86.150969',
      'lat': '41.768552',
      'pinyin': 'Bayingol'
    },
    {
      'pkid': '652900',
      'name': '阿克苏地区',
      'shortName': '阿克苏',
      'lng': '80.265068',
      'lat': '41.170712',
      'pinyin': 'Aksu'
    },
    {
      'pkid': '653000',
      'name': '克孜勒苏柯尔克孜自治州',
      'shortName': '克孜勒苏',
      'lng': '76.172825',
      'lat': '39.713431',
      'pinyin': 'Kizilsu'
    },
    {
      'pkid': '653100',
      'name': '喀什地区',
      'shortName': '喀什',
      'lng': '75.989138',
      'lat': '39.467664',
      'pinyin': 'Kashgar'
    },
    {
      'pkid': '653200',
      'name': '和田地区',
      'shortName': '和田',
      'lng': '79.925330',
      'lat': '37.110687',
      'pinyin': 'Hotan'
    },
    {
      'pkid': '654000',
      'name': '伊犁哈萨克自治州',
      'shortName': '伊犁',
      'lng': '81.317946',
      'lat': '43.921860',
      'pinyin': 'Ili'
    },
    {
      'pkid': '654200',
      'name': '塔城地区',
      'shortName': '塔城',
      'lng': '82.985732',
      'lat': '46.746301',
      'pinyin': 'Qoqek'
    },
    {
      'pkid': '654300',
      'name': '阿勒泰地区',
      'shortName': '阿勒泰',
      'lng': '88.139630',
      'lat': '47.848393',
      'pinyin': 'Altay'
    },
    {
      'pkid': '659000',
      'name': '直辖县级',
      'shortName': ' ',
      'lng': '91.132212',
      'lat': '29.660361',
      'pinyin': ''
    },
    {
      'pkid': '710100',
      'name': '台北市',
      'shortName': '台北',
      'lng': '121.565170',
      'lat': '25.037798',
      'pinyin': 'Taipei'
    },
    {
      'pkid': '710200',
      'name': '高雄市',
      'shortName': '高雄',
      'lng': '120.311922',
      'lat': '22.620856',
      'pinyin': 'Kaohsiung'
    },
    {
      'pkid': '710300',
      'name': '基隆市',
      'shortName': '基隆',
      'lng': '121.746248',
      'lat': '25.130741',
      'pinyin': 'Keelung'
    },
    {
      'pkid': '710400',
      'name': '台中市',
      'shortName': '台中',
      'lng': '120.679040',
      'lat': '24.138620',
      'pinyin': 'Taichung'
    },
    {
      'pkid': '710500',
      'name': '台南市',
      'shortName': '台南',
      'lng': '120.279363',
      'lat': '23.172478',
      'pinyin': 'Tainan'
    },
    {
      'pkid': '710600',
      'name': '新竹市',
      'shortName': '新竹',
      'lng': '120.968798',
      'lat': '24.806738',
      'pinyin': 'Hsinchu'
    },
    {
      'pkid': '710700',
      'name': '嘉义市',
      'shortName': '嘉义',
      'lng': '120.452538',
      'lat': '23.481568',
      'pinyin': 'Chiayi'
    },
    {
      'pkid': '710800',
      'name': '新北市',
      'shortName': '新北',
      'lng': '121.465746',
      'lat': '25.012366',
      'pinyin': 'New Taipei'
    },
    {
      'pkid': '712200',
      'name': '宜兰县',
      'shortName': '宜兰',
      'lng': '121.500000',
      'lat': '24.600000',
      'pinyin': 'Yilan'
    },
    {
      'pkid': '712300',
      'name': '桃园县',
      'shortName': '桃园',
      'lng': '121.083000',
      'lat': '25.000000',
      'pinyin': 'Taoyuan'
    },
    {
      'pkid': '712400',
      'name': '新竹县',
      'shortName': '新竹',
      'lng': '121.160000',
      'lat': '24.600000',
      'pinyin': 'Hsinchu'
    },
    {
      'pkid': '712500',
      'name': '苗栗县',
      'shortName': '苗栗',
      'lng': '120.750000',
      'lat': '24.500000',
      'pinyin': 'Miaoli'
    },
    {
      'pkid': '712700',
      'name': '彰化县',
      'shortName': '彰化',
      'lng': '120.416000',
      'lat': '24.000000',
      'pinyin': 'Changhua'
    },
    {
      'pkid': '712800',
      'name': '南投县',
      'shortName': '南投',
      'lng': '120.830000',
      'lat': '23.830000',
      'pinyin': 'Nantou'
    },
    {
      'pkid': '712900',
      'name': '云林县',
      'shortName': '云林',
      'lng': '120.250000',
      'lat': '23.750000',
      'pinyin': 'Yunlin'
    },
    {
      'pkid': '713000',
      'name': '嘉义县',
      'shortName': '嘉义',
      'lng': '120.300000',
      'lat': '23.500000',
      'pinyin': 'Chiayi'
    },
    {
      'pkid': '713300',
      'name': '屏东县',
      'shortName': '屏东',
      'lng': '120.487928',
      'lat': '22.682802',
      'pinyin': 'Pingtung'
    },
    {
      'pkid': '713400',
      'name': '台东县',
      'shortName': '台东',
      'lng': '120.916000',
      'lat': '23.000000',
      'pinyin': 'Taitung'
    },
    {
      'pkid': '713500',
      'name': '花莲县',
      'shortName': '花莲',
      'lng': '121.300000',
      'lat': '23.830000',
      'pinyin': 'Hualien'
    },
    {
      'pkid': '713600',
      'name': '澎湖县',
      'shortName': '澎湖',
      'lng': '119.566417',
      'lat': '23.569733',
      'pinyin': 'Penghu'
    },
    {
      'pkid': '713700',
      'name': '金门县',
      'shortName': '金门',
      'lng': '118.317089',
      'lat': '24.432706',
      'pinyin': 'Jinmen'
    },
    {
      'pkid': '713800',
      'name': '连江县',
      'shortName': '连江',
      'lng': '119.539704',
      'lat': '26.197364',
      'pinyin': 'Lienchiang'
    },
    {
      'pkid': '810100',
      'name': '香港岛',
      'shortName': '香港岛',
      'lng': '114.177314',
      'lat': '22.266416',
      'pinyin': 'Hong Kong Island'
    },
    {
      'pkid': '810200',
      'name': '九龙',
      'shortName': '九龙',
      'lng': '114.174950',
      'lat': '22.327115',
      'pinyin': 'Kowloon'
    },
    {
      'pkid': '810300',
      'name': '新界',
      'shortName': '新界',
      'lng': '114.202408',
      'lat': '22.341766',
      'pinyin': 'New Territories'
    },
    {
      'pkid': '820100',
      'name': '澳门半岛',
      'shortName': '澳门半岛',
      'lng': '113.549134',
      'lat': '22.198751',
      'pinyin': 'MacauPeninsula'
    },
    {
      'pkid': '820200',
      'name': '氹仔岛',
      'shortName': '氹仔岛',
      'lng': '113.577669',
      'lat': '22.156838',
      'pinyin': 'Taipa'
    },
    {
      'pkid': '820300',
      'name': '路环岛',
      'shortName': '路环岛',
      'lng': '113.564857',
      'lat': '22.116226',
      'pinyin': 'Coloane'
    },
    {
      'pkid': '460400',
      'name': '儋州市',
      'shortName': null,
      'lng': '109.576782',
      'lat': '19.517486',
      'pinyin': null
    },
    {
      'pkid': '500200',
      'name': '重庆市郊县',
      'shortName': '重庆市郊县',
      'lng': '108.170255',
      'lat': '29.291965',
      'pinyin': null
    },
    {
      'pkid': '540400',
      'name': '林芝市',
      'shortName': null,
      'lng': '94.362348',
      'lat': '29.654693',
      'pinyin': null
    },
    {
      'pkid': '650400',
      'name': '吐鲁番市',
      'shortName': null,
      'lng': '89.184078',
      'lat': '42.947613',
      'pinyin': null
    },
    {
      'pkid': '900100',
      'name': '钓鱼岛',
      'shortName': '钓鱼岛',
      'lng': '123.478088',
      'lat': '25.742385',
      'pinyin': 'DiaoyuDao'
    }
    ]
};
